window.okeReviewsWidgetOnInit = function () {
    setUpHeader();
    const reviewContainer = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewContainer) {
        const config = { childList: true };
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                mutation.addedNodes.forEach(n => moveRecommend(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewContainer, config);
    }

    const reviews = document.querySelectorAll('.okeReviews-reviews-review');
    reviews.forEach(n => moveRecommend(n));
};

function moveRecommend(review) {
    if (review) {
        const recommendBadge = review.querySelector('.okeReviews-review-recommendation--yes');
        const reviewMain = review.querySelector('.js-okeReviews-reviewMain');

        if (recommendBadge && reviewMain) {
            recommendBadge.innerText = 'Recommends this product to their family and friends';
            reviewMain.insertAdjacentElement('afterend', recommendBadge);
            recommendBadge.style.visibility = 'visible';
        }
    }
}

// Move reviews aggegrate and review button into control
function setUpHeader() {
    var writeReviewButton = document.querySelector('.js-okeReviews-writeReview');
    var reviewsControlsHeader = document.querySelector('.okeReviews-reviews-controls');
    if (reviewsControlsHeader && writeReviewButton && !writeReviewButton.className.includes('is-okeReviews-hiddenButton')) {
        reviewsControlsHeader.prepend(writeReviewButton);
    }
}